<div class="row animated fadeIn">
    <div class="col-12">
        <div class="card">
            <div class="row" style="margin-left: 2px; margin-top: 15px; margin-right: 2px;">
                <div class="col-md-8">
                    <input #input type="text" class="form-control" placeholder="Buscar Perfiles..." [(ngModel)]="termino">
                </div>
                <div class="col-md-4">
                    <button (click)="filtrar()" type="button" class="btn waves-effect waves-light btn-rounded btn-primary">
                  <i class="fa fa-search"></i>
                    Filtrar
                </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    &nbsp;
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <div class="card">
            <ag-grid-angular #agGrid id="myGrid" style="width: 100%; height: 400px;" class="ag-theme-balham" [rowData]="rowData" [paginationPageSize]="10" [pagination]="true" [columnDefs]="columnDefs" [localeText]="localeText" [rowSelection]="rowSelection" (selectionChanged)="onSelectionChanged($event)"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
</div>